/* eslint-disable max-len */
import { commonMessages } from './common.es.translation';

const messageListSpanish = {
    'AdminDigest.added_application_breakdown':
        'Desglose de la aplicación agregada',
    'AdminDigest.approved_applications': 'Aplicaciones Aprobadas',
    'AdminDigest.classify_application': 'Clasificar Aplicación',
    'AdminDigest.classify_applications': 'Clasificar Aplicaciones',
    'AdminDigest.classify_workflow': 'Clasificar Flujo de Trabajo',
    'AdminDigest.manage_application': 'Administrar la aplicación',
    'AdminDigest.manage_applications': 'Administrar aplicaciones',
    'AdminDigest.new_applications_title': 'Aplicaciones Agregadas',
    'AdminDigest.pending_applications': 'Aplicaciones Pendientes',
    'AdminDigest.title': 'Resumen de Administración',
    'AdminDigest.top_applications': 'Aplicación Más Utilizada Este Mes',
    'AdminDigest.total_applications': 'Total de Aplicaciones Administradas',
    'AdminDigest.unapproved_applications': 'Aplicaciones No Aprobadas',
    'AdminDigest.unclassified_applications_title':
        'Aplicaciones No Clasificadas',
    'AdminDigest.usage_by_status': 'Uso Por Estado',
    'AdminUser.disabled_alert':
        'Este usuario ha sido deshabilitado y ya no recopilará métricas. No podrá iniciar sesión. Puede ejecutar un informe externo a continuación',
    'AdminUser.run_disabled_user_report': 'Generar Reporte Externo',
    'AdminView.admin_dashboard': 'Panel de Administración',
    'AdminView.office_365_setup': 'Integración AD',
    'Alerts.application_in_non_admin_text':
        'Para ver esta aplicación en el panel administrativo, haga clic aquí.',
    'Alerts.applications_in_non_admin_text':
        'Para ver las aplicaciones de su organización, haga clic aquí',
    'Alerts.microsoftEntraID.goToConfigure': 'Para configurar AD presione aquí',
    'Alerts.microsoftEntraID.notConfigured': 'AD no ha sido configurado',
    'Alerts.non_admin_view': 'Estás en una vista no administrativa.',
    'Alerts.organization_in_non_admin_text':
        'Para ver los paneles de control de su organización, haga clic aquí',
    'Alerts.user_in_non_admin_text':
        'Para modificar este usuario en el panel administrativo haga clic aquí',
    'AllClientSettings.brand_enabled': 'Marca Habilitada',
    'AllClientSettings.PartnerBranding': 'Asociación con Marca de Producto',
    'AllClientSettings.product_name': 'Nombre de la Marca',
    'AllClientSettings.select_a_logo': 'Logotipo de la Marca',
    'AllClientSettings.select_new_logo':
        'Seleccione Nuevo Logo Para Cargar (png jpg)',
    'AllClientSettings.set_product_name': '',
    'AllClientSettings.title': 'Configuración Global de Socios',
    'AllClientSettings.upload_logo': 'Seleccione un Logo',
    'AllClientSettings.upload_logo_requirements':
        'Todas las imágenes se redimensionarán a un máximo de 170 píxeles de ancho y un máximo de 50 píxeles de alto. Para obtener los mejores resultados, utilice imágenes sin espacios en blanco en el exterior de los bordes.',
    'AllClientSettings.upload_new_logo': 'Confirmar Logo Seleccionado',
    'ApplicationDashboard.admin_application_dashboard':
        'Biblioteca de aplicaciones',
    'ApplicationDashboard.application_overview':
        'Descripción Feneral de la Aplicación',
    'ApplicationDashboard.last_calculated': 'Última vez calculado <Date/>',
    'ApplicationDashboard.last_week_active_users':
        'Usuarios activos de la semana pasada',
    'ApplicationDashboard.last_weeks_usage': 'Uso de la semana pasada',
    'ApplicationDashboard.manage_application_users':
        'Administrar Usuarios de Aplicación',
    'ApplicationDashboard.manage_users': 'Administrar usuarios de aplicaciones',
    'ApplicationDashboard.managed': 'Administrado',
    'ApplicationDashboard.managed_description':
        'Las aplicaciones se consideran administradas cuando se han agregado al sistema y tienen un propietario comercial adecuado asignado para administrar la plataforma y un estado que no es "Descubierto". Para realizar cambios masivos en las aplicaciones, visite el',
    'ApplicationDashboard.recently_added_users':
        'Usuarios agregados recientemente',
    'ApplicationDashboard.run_reports': 'Ejecturar Reportes',
    'ApplicationDashboard.unclassified': 'Sin Clasificar',
    'ApplicationDashboard.unmanaged': 'Sin Administrar',
    'ApplicationDashboard.unmanaged_description':
        'Las aplicaciones se consideran no administradas cuando se han clasificado en el sistema a través del panel de clasificación de aplicaciones. Estas aplicaciones no se consideran administradas hasta que tengan un estado que no sea "Descubierto" y tengan un propietario de negocio asignado. Para realizar cambios masivos en las aplicaciones, visite el',
    'ApplicationRemove.description':
        'No se recomienda que elimine aplicaciones del panel de control de Auvik SaaS Management. Esto no impedirá que los nuevos usuarios lo agreguen a su panel de control y todos los usuarios existentes tendrán que volver a agregarlo si lo necesitan.',
    'ApplicationRemove.remove': 'Eliminar Aplicación',
    'AuthenticationHandler.logging_in': 'Iniciando Sesión',
    'BulkEditor.description':
        'Aquí podra actualizar de forma masiva aplicaciones con diferentes campos. Seleccione un campo a continuación para comenzar, luego los cambios se realizan instantáneamente a medida que los cambia.',
    'BulkEditor.exclude_section_one': 'Aplicación Excluida con',
    'BulkEditor.exclude_section_two': 'Ya completado',
    'Classify.removed': 'Esta aplicación ha sido eliminada exitosamente',
    'Classify.removed_error': 'Hubo un problema al eliminar la aplicación',
    'Classify.statusSet': 'El estado de la aplicación ha sido actualizada',
    'Classify.success': 'Esta aplicación ha sido clasificada exitosamente',
    'ClassifyModal.application_users': 'Usuarios de la Aplicación',
    'ClassifyModal.purpose_workflow':
        'Flujo de Trabajo, propósito comercial de la aplicación',
    'ClassifyModal.request_purpose': 'Propósito de la Solicitud',
    'ClassifyModal.request_purpose_description':
        'Este flujo de trabajo está diseñado para recopilar información de los empleados que utilizan esta aplicación.',
    'ClassifyModal.requested_users': 'Usuarios Solicitados',
    'ClassifyModal.skipworkflow':
        'Omitir flujo de trabajo y agregar aplicación',
    'ClientSettings.blocked_enabled': 'Agregar Estado Bloqueado al Cliente',
    'ClientSettings.blocked_enabled_description': '',
    'ClientSettings.title': 'Configuracion del Cliente',
    'Colors.auvikBrown': 'Marrón',
    'Colors.auvikCyan': 'Cian',
    'Colors.auvikEggplant': 'Berenjena',
    'Colors.auvikGreen': 'Verde',
    'Colors.auvikLavender': 'Lavanda',
    'Colors.auvikLime': 'Lima',
    'Colors.auvikOrange': 'Naranja',
    'Colors.auvikPink': 'Rosa',
    'Colors.auvikPurple': 'Púrpura',
    'Colors.auvikRed': 'Rojo',
    'Colors.auvikSkyBlue': 'Azul',
    'Colors.auvikYellow': 'Amarillo',
    'Configure.bulk_editor':
        'Aquí puede editar aplicaciones de forma masiva y cambiar cosas como',
    'Configure.classify':
        'Las aplicaciones se consideran no clasificadas si han sido utilizadas por un miembro de la organización. La clasificación de una aplicación moverá la aplicación al panel de aplicaciones no administradas, donde necesitarán un propietario de negocio y un estado que no sea "Descubierto" asignado.',
    'Configure.client_settings': '',
    'Configure.devices':
        'Aquí puede ver sus dispositivos, su estado de acceso SSO, etc. También puede recuperar el comando de implementación aquí.',
    'Configure.identity_management_description':
        'Aquí puede configurar la Integración de Microsoft Entra ID o Google Workspace, obtener sus comandos de implementación y administrar usuarios y grupos en AAD.',
    'Configure.new_user_experience':
        'Aquí puede configurar qué experiencia obtiene un nuevo usuario cuando se carga Auvik SaaS Management por primera vez. Personalice la experiencia para su negocio.',
    'Configure.permissions':
        'Aquí puede restringir el acceso a diferentes componentes del sistema SAuvik SaaS Managementaaslio. Configure los permisos predeterminados y los grupos de permisos aquí.',
    'Configure.tag_editor': 'Aquí puede editar sus etiquetas',
    'Configure.title': 'Utilidades de la Plataforma',
    'ConfigureSelfUser.error.email': 'Correo electrónico es requerido.',
    'ConfigureSelfUser.error.first_name': 'Primer nombre es requerido.',
    'ConfigureSelfUser.error.last_name': 'Apellido es requerido.',
    'ConfigureSelfUser.error_saving':
        'Tuvimos un problema al guardar tu configuración. Por favor, actualice e intente nuevamente.',
    'ConfigureSelfUser.success_saving': 'Su configuración ha sido actualizada',
    'ConfigureSelfUser.update_information': 'Actualizar Información',
    'ConfigureSelfUser.view_my_applications': 'Vista de mis aplicaciones',
    'Deployment.deployment_guide': 'Documentación de la Guía de Implementación',
    'Deployment.instructions_section_two':
        'Para más información favor leer nuestro',
    'DevicesDashboard.title': 'Dispositivos',
    'Home.admin_dashboard': 'Panel de Administración',
    'Home.application_insights': 'Mis Conocimientos de la Aplicación ',
    'Home.application_library': 'Mi Librería de Aplicaciones',
    'Home.description':
        'Auvik SaaS Management ayuda a su empresa a comprender qué software es eficaz. Eres parte de este viaje. ',
    'Home.personal_settings': 'Ajustes personales',
    'Home.quick_start': 'Guía Rapida',
    'Home.session_paused':
        'Su sesion está pausada, Presione Aquí Para Reanudar',
    'Home.title': 'Ayude a potenciar las decisiones tecnologicas de su empresa',
    'Login.check_out_website': 'Entra a nuestra página web para conocer más',
    'Login.first_step': 'Primer paso para iniciar sesión con su proveedor',
    'Login.message':
        '¡Estamos emocionados que comience su viaje en el uso de sus plataformas SaaS existentes de la manera más eficiente posible!',
    'Login.title': 'Hola!',
    'Logout.go_to_login': 'Iniciar Sesión',
    'Logout.message': 'Regrese Pronto',
    'ManageApplication.add_to_library': 'Agregar Aplicación a la Librería',
    'ManageApplication.are_you_sure': 'Está seguro?',
    'ManageApplication.create_new_tag': 'Crear Etiqueta de Aplicación',
    'ManageApplication.error_application_load':
        'Ocurrio un problema al cargar los ajustes de la aplicación',
    'ManageApplication.error_saving':
        'Hubo un problema al actualizar sus preferencias, porfavor recargue la página é intente nuevamente',
    'ManageApplication.management_setting':
        'Mi configuración para la administración de aplicaciones',
    'ManageApplication.managing_application': 'Administrar esta Aplicación',
    'ManageApplication.my_expertise': 'Mi experiencia con esta aplicación',
    'ManageApplication.prompt_are_you_sure':
        'Esto eliminará todo el historial con la aplicación. Esta acción no se puede deshacer y no es reversible.',
    'ManageApplication.remove_from_library': 'Eliminar de la Librería',
    'ManageApplication.settings_saved':
        'Sus ajustes han sido guardados con éxito',
    'ManageApplication.successful_add':
        'La aplicación ha sido agregada con éxito a su librería',
    'ManageApplication.unable_to_load':
        'Se intento cargar la configuración de la aplicación sin enlace y falló.',
    'ManageApplication.unable_to_load_team': 'No puede liderar el equipo',
    'ManageApplicationAdmin.add_application_admin':
        'Habilitar administrador de apliaciones',
    'ManageApplicationAdmin.add_first_link': 'Agregar Primer Enlace',
    'ManageApplicationAdmin.add_to_dashboard': 'Agregar al Panel',
    'ManageApplicationAdmin.custom_links_error':
        'No se puede guardar el enlance personalizado',
    'ManageApplicationAdmin.custom_links_updated':
        'Se han actualizado los enlaces personalizados',
    'ManageApplicationAdmin.custom_links_verbiage':
        'Puede agregar hasta 3 enlaces personalizados que se pueden compartir en toda la organización para que los usuarios los vean.',
    'ManageApplicationAdmin.default_settings_error':
        'Problema al guardar la configuración predeterminada',
    'ManageApplicationAdmin.default_settings_saved':
        'La configuración predeterminada se ha actualizado.',
    'ManageApplicationAdmin.default_verbiage':
        'Estas configuraciones se utilizaran para informes de flujos de trabajo y visualización de aplicaciones dentro de los paneles de Auvik SaaS Management.',
    'ManageApplicationAdmin.deploy_to_all':
        'Implementar en todos los paneles de control de los usuarios',
    'ManageApplicationAdmin.enable_prompt':
        'Esta aplicación deberá solicitar a los usuarios que la agreguen a su panel de control.',
    'ManageApplicationAdmin.error_adding':
        'Problema al agregar la apliación al usuario.',
    'ManageApplicationAdmin.error_loading':
        'Hubo un problema al cargar el panel de administración',
    'ManageApplicationAdmin.error_revoking':
        'Problema al revocar la solicitud del usuario.',
    'ManageApplicationAdmin.error_updating_admin':
        'Tuvimos un problema al cargar el estado de administrador para este usuario',
    'ManageApplicationAdmin.licensed': 'Licencia',
    'ManageApplicationAdmin.nav_custom_links': 'Enlaces Personalizados',
    'ManageApplicationAdmin.nav_permissions_and_access': 'Permisos y Accesos',
    'ManageApplicationAdmin.no_category_selected':
        'No ha seleccionado una categoria',
    'ManageApplicationAdmin.no_tenant_link':
        'No hay usuarios utilizando esta aplicación, por lo que, no hay nada que administrar.',
    'ManageApplicationAdmin.no_user_selected':
        'No hay Dueño de Empresa Asignado',
    'ManageApplicationAdmin.note': 'Nota',
    'ManageApplicationAdmin.permission_and_access':
        'Aquí, puede determinar los administradores en la plataforma Auvik SaaS Management para esta aplicación. Estos administradores pueden configurar flujos de trabajo, ejecutar informes y configurar ajustes para esta aplicación. También puede definir qué usuarios tienen una licencia activa para la aplicación, también a continuación',
    'ManageApplicationAdmin.removed_app_successfully':
        'Esta aplicación a sido eliminada de todos los paneles con éxito',
    'ManageApplicationAdmin.save_nav_links_settings':
        'Guardar configuración de enlace personalizado',
    'ManageApplicationAdmin.successful_deploy':
        'Esta aplicación ha sido implementada exitosamente en el panel de control de los usuarios. ',
    'ManageApplicationAdmin.tenant_settings': 'Configuraciones del Cliente',
    'ManagedTable.noResults': 'Sin resultados.',
    'ManagedTable.search': 'Busqueda',
    'MicrosoftAuthenticationHandler.c': 'Iniciar Sesión con Microsoft',
    'Mocking.click_here': 'Haga clic aquí para reanudar su sesión',
    'Mocking.info':
        'Actualmente está simulando una organización cliente. Para reanudar su sesión, cierre la sesión y vuelva a iniciar sesión como su usuario. Si vuelve a cargar su navegador, se cerrará automáticamente la sesión.',
    'Navigation.admin_dashboard': 'Panel de Administración',
    'Navigation.application_insights': 'Perspectivas de la aplicación',
    'Navigation.application_library': 'Librería de Aplicación',
    'Navigation.customized_report': 'Informe Personalizado',
    'Navigation.dashboard': 'Panel ',
    'Navigation.office_365_configuration': 'Configuración Microsoft Entra ID',
    'Navigation.organization': 'Organización',
    'Navigation.personal_settings': 'Ajustes Personales',
    'Navigation.report_builder': 'Generador de informes',
    'Navigation.setup_new_report': 'Configurar Reporte Nuevo',
    'PartnerInformation.city': 'Ciudad',
    'PartnerInformation.name': 'Nombre de la Organización',
    'PartnerInformation.phone': 'Número de Teléfono',
    'PartnerInformation.state': 'Estado',
    'PartnerInformation.streetAddress': 'Dirección',
    'PartnerInformation.title': 'Información de Socio',
    'PartnerInformation.zip': 'Código Postal',
    'PartnerOrganization.add_client': 'Agregar Cliente',
    'PartnerOrganization.client_organizations': 'Administrar Clientes',
    'PartnerOrganization.success_create':
        'Este cliente se ha vinculado con éxito a su panel de asociado.',
    'PartnerOrganizations.login_to_organization':
        'Iniciar sesión en la organización',
    'Permissions.default_new_user':
        'Permiso predeterminado para nuevos usuarios',
    'Permissions.default_permissions':
        'Este es un permiso predeterminado y algunas configuraciones no se pueden cambiar.',
    'Provider.MicrosoftConfiguration.application_id':
        'Identificacion para la Aplicación Microsoft Entra ID',
    'Provider.MicrosoftConfiguration.application_secret':
        'Secreto de la aplicación de Microsoft Entra ID',
    'Provider.MicrosoftConfiguration.configuration_title':
        'Microsoft 365 Directorio Activo - Configuración',
    'Provider.MicrosoftConfiguration.deployment':
        'Implementación Auvik SaaS Management',
    'Provider.MicrosoftConfiguration.error_disable_group':
        'Encontré un problema',
    'Provider.MicrosoftConfiguration.error_load_group': 'Encontré un problema',
    'Provider.MicrosoftConfiguration.error_loading_settings':
        'No se puede cargar la configuración.',
    'Provider.MicrosoftConfiguration.error_loading_users':
        'Error o privilegios insuficientes con la aplicación para cargar usuarios.',
    'Provider.MicrosoftConfiguration.error_saving_group':
        'Encontré un problema',
    'Provider.MicrosoftConfiguration.error_user_delete':
        'Ocurrio un problema al tratar de eliminar este usuario',
    'Provider.MicrosoftConfiguration.groups_title':
        'Microsoft 365 Directorio Activo - Grupos ',
    'Provider.MicrosoftConfiguration.identity_provider':
        'Proveedor de identidad',
    'Provider.MicrosoftConfiguration.identity_provider_sync_enabled':
        'Sincronización Habilitada',
    'Provider.MicrosoftConfiguration.identity_provider_unique_id':
        'Identificación única del proveedor de identidad',
    'Provider.MicrosoftConfiguration.macos_deployment_command':
        'Comando de implementacion para MacOS',
    'Provider.MicrosoftConfiguration.no_save':
        'No pudimos guardar los ajustes porque no se pudo validar sus credenciales',
    'Provider.MicrosoftConfiguration.no_users':
        'No se encontraron usuarios en este grupo',
    'Provider.MicrosoftConfiguration.re_enter_secret':
        'El secreto no se puede ver después de guardar.',
    'Provider.MicrosoftConfiguration.success_group_added':
        'Este grupo se ha creado y está habilitado en sus informes.',
    'Provider.MicrosoftConfiguration.success_group_removed':
        'Este grupo se ha eliminado y ya no aparecerá en sus informes.',
    'Provider.MicrosoftConfiguration.success_user_deleted': 'Usuario Eliminado',
    'Provider.MicrosoftConfiguration.sync_disabled':
        'Sincronización de Microsoft Entra ID esta deshabilitada',
    'Provider.MicrosoftConfiguration.sync_enabled':
        'Sincronización de Microsoft Entra ID esta habilitada',
    'Provider.MicrosoftConfiguration.tenant_id':
        'ID Cliente Microsoft Entra ID',
    'Provider.MicrosoftConfiguration.users_title':
        'Microsoft 365 Directorio Activo - Usuarios',
    'Provider.MicrosoftConfiguration.windows_deployment_command':
        'Comando de implementación para Windows',
    'Provider.Shared.error_saving_user':
        'No se puede guardar usuario, actualice e intente nuevamente.',
    'Provider.Shared.saved':
        'Configuración de sincronización de identidad guardada.',
    'Provider.Shared.success_user_added': 'Usuario Agregado Existosamente',
    'Report.no_data_notice':
        '¡Este informe parece estar en blanco! Es probable que esto se deba a que no hubo datos sobre los que informar en el período de tiempo seleccionado.',
    'Reports.ApplicationReport.map_breakdown':
        'Desglose de Aplicaciones Relacionadas',
    'Reports.ApplicationReport.map_overview':
        'Mapa de Aplicación - Las 20 Más Utilizadas',
    'Reports.ApplicationReport.map_overview_usage':
        'Aplicaciones Relacionadas Comparación por Uso (20 principales)',
    'Reports.ApplicationReport.map_overview_users':
        'Aplicaciones Relacionadas Comparación por Usuarios (20 principales)',
    'Reports.CategoryReport.category_breakdown': 'Desglose de Categoria',
    'Reports.CategoryReport.category_overview':
        'Descripción General de Categoría',
    'Reports.Device.detailed_usage':
        'Uso detallado de la aplicación en dispositivo',
    'Reports.DiscoveryReport.business_owner_assignment_breakdown':
        'Desglose de la asignación del propietario de la empresa',
    'Reports.DiscoveryReport.business_owner_assignment_overview':
        'Descripción general de la asignación de propietario de negocio',
    'Reports.DiscoveryReport.discovery_application_breakdown':
        'Desglose de la Aplicación',
    'Reports.DiscoveryReport.discovery_overview': 'Visión General',
    'Reports.DiscoveryReport.status_assignment_breakdown': 'Desglose de Estado',
    'Reports.DiscoveryReport.status_assignment_overview': 'Resumen de Estado',
    'Reports.DiscoveryReport.tag_assignment_breakdown':
        'Desglose de las etiquetas asignadas.',
    'Reports.error_one_report': 'Seleccione al menos un reporte para ejecutar',
    'Reports.LibraryReport.library_overview': 'Resumen de Librería',
    'Reports.my_reports': 'Mis Reportes',
    'Reports.ProceduralCodes.application': 'Aplicación',
    'Reports.ProceduralCodes.Application Breakdown':
        'Desglose de la aplicación',
    'Reports.ProceduralCodes.Application Map': 'Aplicaciones Relacionadas',
    'Reports.ProceduralCodes.Application Status Report':
        'Reportes de Estados de la Aplicación',
    'Reports.ProceduralCodes.Breakdown': 'Desglose',
    'Reports.ProceduralCodes.Category Reports': 'Reporte de Categoría',
    'Reports.ProceduralCodes.daily': 'Diariamente',
    'Reports.ProceduralCodes.Daily Breakdown': 'Desglose Diario',
    'Reports.ProceduralCodes.Daily Overview': 'Resumen Diario',
    'Reports.ProceduralCodes.device': 'Dispositivo',
    'Reports.ProceduralCodes.Device Breakdown Report':
        'Uso de la aplicación por dispositivo',
    'Reports.ProceduralCodes.Discovery Reports': 'Reportes de Descubrimiento',
    'Reports.ProceduralCodes.Hourly Breakdown': 'Desglose por hora',
    'Reports.ProceduralCodes.individual': 'Personal',
    'Reports.ProceduralCodes.Library Changes': 'Cambios en la Librería',
    'Reports.ProceduralCodes.Library Reports': 'Reporte de Librería',
    'Reports.ProceduralCodes.license': 'Licencia',
    'Reports.ProceduralCodes.License Breakdown Report':
        'Uso de Licencia Detallado',
    'Reports.ProceduralCodes.monthly': 'Mensualmente',
    'Reports.ProceduralCodes.offboard': 'Reportes Externos',
    'Reports.ProceduralCodes.Organization Report': 'Reporte Organizacional',
    'Reports.ProceduralCodes.organizational': 'Organizacional',
    'Reports.ProceduralCodes.Overview': 'Vision General',
    'Reports.ProceduralCodes.Overview Breakdown': 'Desglose General',
    'Reports.ProceduralCodes.Personal Report': 'Reporte Personal',
    'Reports.ProceduralCodes.Risk Analysis': 'Analisis de Riesgo',
    'Reports.ProceduralCodes.status': 'Estado',
    'Reports.ProceduralCodes.Status Report': 'Reportes de Estado',
    'Reports.ProceduralCodes.Usage And Overlap': 'Uso y Superposición',
    'Reports.ProceduralCodes.Usage Reports': 'Informe de Uso',
    'Reports.ProceduralCodes.Usage Vs Adoption': 'Uso Vs. Adopción',
    'Reports.ProceduralCodes.User Offboard Report': 'Reportes Externos',
    'Reports.ProceduralCodes.User Status Report':
        'Informe de Estado de Usuario',
    'Reports.ProceduralCodes.weekly': 'Semanalmente',
    'Reports.prompt_crunching_report':
        '¡Actualmente procesando su informe personalizado!',
    'Reports.remove_inactive': 'Eliminar inactividad del informe',
    'Reports.remove_personal': 'Eliminar aplicaciones personales del informe',
    'Reports.removeBrowser': 'Eliminar navegadores del informe',
    'Reports.report_applications': 'Reportes de Aplicación',
    'Reports.report_category': 'Desglose de Categoría',
    'Reports.report_device': 'Informes de Dispositivos',
    'Reports.report_discovery': 'Reporte de Descubrimiento',
    'Reports.report_library': 'Reporte de Librería',
    'Reports.report_license': 'Reportes de Licencia',
    'Reports.report_offboard': 'Informes Externos',
    'Reports.report_setup': 'Configuración de informes',
    'Reports.report_status': 'Reportes de Estado',
    'Reports.report_usage': 'Resumen de Uso',
    'Reports.ReportBuilder.all': 'Todo ',
    'Reports.ReportBuilder.all_users_and_groups': 'Todos los usuarios / grupos',
    'Reports.ReportBuilder.approved': 'Aprobado',
    'Reports.ReportBuilder.certain_applications': 'Seleccionar Aplicación',
    'Reports.ReportBuilder.certain_categories': 'Seleccionar Categoria',
    'Reports.ReportBuilder.certain_groups': 'Seleccionar ciertos grupos',
    'Reports.ReportBuilder.certain_statuses': 'Seleccionar Estado',
    'Reports.ReportBuilder.certain_tags': 'Seeccionar Etiquetas',
    'Reports.ReportBuilder.certain_users': 'Seleccionar ciertos usuarios',
    'Reports.ReportBuilder.narrow_applications':
        'Seleccione sobre qué aplicaciones informar',
    'Reports.ReportBuilder.narrow_status':
        'Seleccione el estado de la aplicación sobre cual informar',
    'Reports.ReportBuilder.narrow_users':
        'Seleccione los usuarios sobre los que informar',
    'Reports.ReportBuilder.not_approved': 'No aprobado',
    'Reports.ReportBuilder.not_configured': 'No configurado',
    'Reports.ReportBuilder.overview_matrix_tags':
        'Seleccionar etiquetas para mostrar en la matriz de descripción general',
    'Reports.ReportBuilder.select_day':
        'Seleccione el día para ejecutar su informe',
    'Reports.ReportBuilder.select_month':
        'Seleccione el mes para ejecutar su informe',
    'Reports.ReportBuilder.select_period': 'Seleccione el Periodo del Reporte ',
    'Reports.ReportBuilder.select_quarter': 'Seleccione su Reporte Trimestral',
    'Reports.ReportBuilder.select_sub_report':
        'Seleccione sus opciones de sub-informe',
    'Reports.ReportBuilder.select_type': 'Seleccione Tipo de Reporte',
    'Reports.ReportBuilder.select_week':
        'Seleccione una semana para ejecutar su informe',
    'Reports.ReportSummary.advanced_report_details':
        'Detalles de Informe Avanzado',
    'Reports.ReportSummary.sub_reports': 'Sub-Reportes',
    'Reports.run_report': 'Generar Reporte',
    'Reports.save_and_schedule': 'Guardar y Programar Informe',
    'Reports.Schedule.error': 'Error al programar informe.',
    'Reports.Schedule.error_select_user':
        'Debe seleccionar un usuario a quien enviar reporte',
    'Reports.Schedule.select_user_email':
        'Seleccione el Usuario a Quien Enviar Reporte',
    'Reports.Schedule.success': 'Su reporte ha sido guardado',
    'Reports.ScheduledReport.error_loading_reports':
        'Problema al cargar informes programados.',
    'Reports.ScheduledReport.error_removing_report':
        'Hubo un problema al eliminar este informe de su panel.',
    'Reports.ScheduledReport.report_configuration': 'Configuración de Reporte',
    'Reports.ScheduledReport.success_remove':
        'Este informe ha sido eliminado exitosamente de su panel de control.',
    'Reports.ScheduledReport.view_full_report':
        'Ver configuración completa del informe',
    'Reports.UsageReport.adoption_and_usage': 'Adopción y Uso de la Aplicación',
    'Reports.UsageReport.application_users': 'Usuarios de la aplicación',
    'Reports.UsageReport.average_usage': 'Uso promedio (uso / usuarios)',
    'Reports.UsageReport.usage_breakdown': 'Desglose de Uso',
    'Reports.UsageReport.usage_daily_breakdown': 'Desglose de Uso Diario',
    'Reports.UsageReport.usage_overview': 'Resumen de Uso',
    'Reports.view_advanced_setup': 'Ver Configuración Avanzada de Informes',
    'ReportSelection.title': 'Reportes',
    'Setup.nav_apps': 'Configure sus aplicaciones.',
    'Setup.nav_tenant': 'Déjanos saber sobre tu organización',
    'Setup.nav_user': 'Déjanos saber sobre ti',
    'SetupTenant.error_name_required':
        'Proporcione un nombre de organización, no se podrá cambiar una vez configurado',
    'SetupTenant.error_saving': 'Error al Salvar Ajustes',
    'SetupTenant.organization_name': 'Nombre de Organización',
    'SetupTenant.organization_size': 'Tamaño de Organización',
    'SetupTenant.title_prompt':
        'Simplemente termine de completar algunos datos para nosotros y estamos listos para comenzar.',
    'SetupTenant.welcome': 'Bienvenido a Auvik SaaS Management!',
    'SetupUser.accept_tos':
        'He leido y aceptados los <a href="https://www.auvik.com/terms/" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="termsAndConditions"><b>Términos y Condiciones</b></a> y comprendido el <a href="https://www.auvik.com/privacy-policy/" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="dataPrivacyPolicy"><b>Aviso de Privacidad de Datos</b></a>.',
    'SetupUser.error_accept_tos': 'Debe acceptar los términos y condiciones',
    'SetupUser.error_all_fields': 'Debe completar todos los campos',
    'SetupUser.error_saving_settings': 'Error al Salvar Ajustes',
    'SetupUser.get_started': 'Comencemos ',
    'SetupUser.prompt_photo': 'Te ves muy bien!, prefieres una toma diferente?',
    'SetupUser.save_and_continue': 'Guardar y Continuar',
    'SetupUser.title_prompt':
        '¡Bienvenido a Auvik SaaS Management! Simplemente bríndenos algo de información y estaremos listos para comenzar. Echa un vistazo a nuestra <a href="https://www.auvik.com/saas-management/" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="visitOutWebsiteInitialSetup"><b>página</b></a> para entender como funciona Auvik SaaS Management!',
    'Sidebar.bulk_editor': 'Editor masivo de aplicaciones',
    'Sidebar.classify': 'Clasificación de la Aplicación',
    'Sidebar.client_settings': 'Configuracion del Cliente',
    'Sidebar.deployment': 'Implementación',
    'Sidebar.devices': 'Dispositivos',
    'Sidebar.id_management_integration': 'Integración de manejo de identidad',
    'Sidebar.new_user_experience': 'Experiencia de Nuevo Usuario',
    'Sidebar.permissions': 'Permisos',
    'Sidebar.tag_editor': 'Editor de etiquetas',
    'TagEditor.add_new_tag': 'Agregar una nueva etiqueta de aplicación',
    'TagEditor.create_new_tag': 'Crear Etiqueta',
    'TagEditor.default_tag': 'Etiqueta Predeterminada',
    'TagEditor.description':
        'Agregar Nueva Etiqueta de Aplicación ó Editar Las Ya Existentes',
    'TagEditor.edit_tag': 'Editar Etiqueta de Aplicación Existente',
    'TagEditor.tag': 'Etiqueta',
    'TagEditor.title': 'Editor de Etiquetas de Aplicación',
    'UserAdminAplications.description':
        'Como administrador, puede establecer si un usuario tiene una aplicación agregada a su panel de control. También puede habilitarlos para que sean administradores en la plataforma.',
    'UserAdminSettings.description':
        'Como administrador, puede deshabilitar los usuarios para que no cuenten contra su límite de licencia, así como establecer otros administradores de cliente.',
    'UserAdminSettings.user_admin': 'Administrador de Cliente',
    'UserAdminSettings.user_disabled': 'Deshabilitar usuario.',
    'UserAdminSettings.user_disabled_subtext':
        '(Esto los eliminará de todos los informes, no les permitirá iniciar sesión y bloqueará la gestión de la actividad del usuario)',
    'UserAdminSettings.user_management': 'Gestión de usuarios',
    'UserAdminSettings.user_permissions': 'Permisos',
    'UserAdminSettings.user_settings_saved':
        'Configuración de usuario guardada con éxito.',
    'UserAdminSettings.view_permissions': 'Visualizar Permisos',
    'UserDashboard.last_app_added': 'Última aplicación agregada <Date/>',
    'UserDashboard.last_calculated': 'Última vez calculado <Date/>',
    'UserDashboard.last_week_active_applications':
        'Aplicaciones activas de la semana pasada',
    'UserDashboard.last_week_active_users':
        'Usuarios activos de la semana pasada',
    'UserDashboard.recently_added_applications':
        'Aplicaciones agregadas recientemente',
    'UserDashboard.run_reports': 'Ejecturar Reportes',
    'UserDashboard.title': 'Panel de Aplicación de Usuario',
    'UserDashboard.view_applications': 'Visualizar Aplicaciones',
    'UserProfileImageChange.description':
        'Todas las fotos deben tener un tamaño inferior a 1024x1024 y se cambiarán de tamaño. Estas fotos son públicas y visibles para todo su equipo.',
    'UserProfileImageChange.new_photo_selected':
        'Cargar Fotografía Seleccionada',
    'UserProfileImageChange.select_new_photo': 'Seleccionar Nueva Fotografía',
    'UserProfileImageChange.success':
        'Su foto de perfil ha sido actualizada exitosamente',
    'UserProfileImageChange.title': 'Cambiar Fotografía',
    'UserProfileImageChange.title_descriptive':
        'Cargar Nueva Fotografía de Perfil ',
    'UserProfileImageChange.upload_new_photo': 'Cargar Nueva Fotografía',
    ...commonMessages
};

export default messageListSpanish;
